import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { ApiConfig } from '@/config/api.config';

export const useSupportEmailRequestAttachmentDownload = () => {
    const axiosInstance = useAxiosAuth();

    const downloadAttachment = async (fileKey: string) => {
        const encodedKey = fileKey.split('/').map(encodeURIComponent).join('/');
        const url = `${ApiConfig.queries.superAdmin.storage.endpoints.privateDownload}/${encodedKey}?expiresInMinutes=15`;
        const response = await axiosInstance.get<{ url: string }>(url);
        window.open(response.data.url, '_blank', 'noopener,noreferrer');
    };

    return { downloadAttachment };
};
